// packages/creatr-devtools/src/index.tsx
'use client';

export { DevtoolsProvider } from './DevtoolsProvider';   // now safe
export { initMiniSentry } from './minisentry';
export { createIframeProxy } from './messaging/createProxy';

export type {
	MiniSentryEvent,
	ElementMetadata,
	IframeMessage,
	InspectorCommand,
	InspectorEvent
} from './types';
